module.exports = __webpack_public_path__ + "static/media/HalvettCondensedBold.591d1e91.woff2";